export function initGlobalAnnouncement(): void {
  const container = document.querySelector<HTMLElement>('.js-global-announcement');
  if (container) {
    initAnnouncementToggle(container);
  }

  initAnnouncementToggle(document.querySelector('.js-announcement-preview'));
  initAnnouncementFormDatePickers();
}

function initAnnouncementToggle(wrapper: HTMLElement | null) {
  if (!wrapper) return;
  const toggleButton = wrapper.querySelector<HTMLButtonElement>('.js-toggle-announcement');
  if (!toggleButton) return;
  const expandLabel = toggleButton.getAttribute('data-expand-label') ?? toggleButton.getAttribute('aria-label') ?? '';
  const collapseLabel = toggleButton.getAttribute('data-collapse-label') ?? expandLabel;
  const setExpanded = (expanded: boolean) => {
    wrapper.classList.toggle('is-expanded', expanded);
    toggleButton.setAttribute('aria-label', expanded ? collapseLabel : expandLabel);
    toggleButton.setAttribute('aria-expanded', String(expanded));
  };
  setExpanded(wrapper.classList.contains('is-expanded'));
  toggleButton.addEventListener('click', (e) => {
    e.preventDefault();
    setExpanded(!wrapper.classList.contains('is-expanded'));
  });
}



function initAnnouncementFormDatePickers() {
  const startPicker = document.querySelector<HTMLInputElement>('#announcement-start-picker');
  const endPicker = document.querySelector<HTMLInputElement>('#announcement-end-picker');
  const startUnix = document.querySelector<HTMLInputElement>('#announcement-start-unix');
  const endUnix = document.querySelector<HTMLInputElement>('#announcement-end-unix');
  if (!startPicker || !endPicker || !startUnix || !endUnix) return;

  const attachListener = (picker: HTMLInputElement, target: HTMLInputElement) => {
    const setUnixValue = () => {
      const value = picker.value;
      if (!value) {
        target.value = '';
        return;
      }
      const unix = Math.floor(new Date(value).getTime() / 1000);
      target.value = unix.toString();
    };
    picker.addEventListener('change', setUnixValue);
    picker.addEventListener('input', setUnixValue);
    setUnixValue();
  };

  attachListener(startPicker, startUnix);
  attachListener(endPicker, endUnix);
}
